/** CoStar.Api.AptsUser.ViewModels.Brand */
export var Brand;
(function (Brand) {
    Brand[Brand["Unknown"] = 0] = "Unknown";
    Brand[Brand["ApartmentsDotcom"] = 1] = "ApartmentsDotcom";
    Brand[Brand["ApartmentFinder"] = 2] = "ApartmentFinder";
})(Brand || (Brand = {}));
import { MoveInTimeframe } from "../../../../CoStar/Api/AptsNet/Aggregate/ViewModels/Messaging/index.js";
/** CoStar.Api.AptsUser.ViewModels.MoveInTimeframe */
export { MoveInTimeframe };
import { ContactOption } from "../../../../CoStar/Api/AptsNet/Aggregate/ViewModels/Messaging/index.js";
/** CoStar.Api.AptsUser.ViewModels.ContactOption */
export { ContactOption };
import { MoveReason } from "../../../../CoStar/Api/AptsNet/Aggregate/ViewModels/Messaging/index.js";
/** CoStar.Api.AptsUser.ViewModels.MoveReason */
export { MoveReason };
import { PetType } from "../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.AptsUser.ViewModels.PetType */
export { PetType };
import { NotificationFrequency } from "../../../../CoStar/Api/AptsNet/Aggregate/ViewModels/RegisterUser/index.js";
/** CoStar.Api.AptsUser.ViewModels.NotificationFrequency */
export { NotificationFrequency };
/** CoStar.Api.AptsUser.ViewModels.NotificationMediums */
export var NotificationMediums;
(function (NotificationMediums) {
    NotificationMediums[NotificationMediums["None"] = 0] = "None";
    NotificationMediums[NotificationMediums["Email"] = 1] = "Email";
    NotificationMediums[NotificationMediums["Sms"] = 2] = "Sms";
})(NotificationMediums || (NotificationMediums = {}));
import { NotificationSubscriptions } from "../../../../CoStar/Api/AptsNet/Aggregate/ViewModels/RegisterUser/index.js";
/** CoStar.Api.AptsUser.ViewModels.NotificationSubscriptions */
export { NotificationSubscriptions };
/** CoStar.Api.AptsUser.ViewModels.Gender */
export var Gender;
(function (Gender) {
    Gender[Gender["Unknown"] = 0] = "Unknown";
    Gender[Gender["Male"] = 1] = "Male";
    Gender[Gender["Female"] = 2] = "Female";
})(Gender || (Gender = {}));
/** CoStar.Api.AptsUser.ViewModels.MaritalStatus */
export var MaritalStatus;
(function (MaritalStatus) {
    MaritalStatus[MaritalStatus["Unknown"] = 0] = "Unknown";
    MaritalStatus[MaritalStatus["Married"] = 1] = "Married";
    MaritalStatus[MaritalStatus["NotMarried"] = 2] = "NotMarried";
})(MaritalStatus || (MaritalStatus = {}));
/** CoStar.Api.AptsUser.ViewModels.IncomeRange */
export var IncomeRange;
(function (IncomeRange) {
    IncomeRange[IncomeRange["Unknown"] = 0] = "Unknown";
    IncomeRange[IncomeRange["UpTo35K"] = 1] = "UpTo35K";
    IncomeRange[IncomeRange["UpTo75K"] = 2] = "UpTo75K";
    IncomeRange[IncomeRange["UpTo125K"] = 3] = "UpTo125K";
    IncomeRange[IncomeRange["MoreThan125K"] = 4] = "MoreThan125K";
})(IncomeRange || (IncomeRange = {}));
/** CoStar.Api.AptsUser.ViewModels.MultifactorAuthenticationStatus */
export var MultifactorAuthenticationStatus;
(function (MultifactorAuthenticationStatus) {
    MultifactorAuthenticationStatus[MultifactorAuthenticationStatus["Unknown"] = 0] = "Unknown";
    MultifactorAuthenticationStatus[MultifactorAuthenticationStatus["On"] = 1] = "On";
    MultifactorAuthenticationStatus[MultifactorAuthenticationStatus["Off"] = 2] = "Off";
    MultifactorAuthenticationStatus[MultifactorAuthenticationStatus["RequiredOn"] = 3] = "RequiredOn";
    MultifactorAuthenticationStatus[MultifactorAuthenticationStatus["RequiredOff"] = 4] = "RequiredOff";
})(MultifactorAuthenticationStatus || (MultifactorAuthenticationStatus = {}));
import { CommuteTravelMode } from "../../../../CoStar/Api/AptsNet/Aggregate/ViewModels/index.js";
/** CoStar.Api.AptsUser.ViewModels.CommuteTravelMode */
export { CommuteTravelMode };
/** CoStar.Api.AptsUser.ViewModels.UserSearchFields */
export var UserSearchFields;
(function (UserSearchFields) {
    UserSearchFields[UserSearchFields["None"] = 0] = "None";
    UserSearchFields[UserSearchFields["Email"] = 1] = "Email";
    UserSearchFields[UserSearchFields["FirstName"] = 2] = "FirstName";
    UserSearchFields[UserSearchFields["LastName"] = 4] = "LastName";
    UserSearchFields[UserSearchFields["Phone"] = 8] = "Phone";
})(UserSearchFields || (UserSearchFields = {}));
/** CoStar.Api.AptsUser.ViewModels.UserSearchStatuses */
export var UserSearchStatuses;
(function (UserSearchStatuses) {
    UserSearchStatuses[UserSearchStatuses["None"] = 0] = "None";
    UserSearchStatuses[UserSearchStatuses["Active"] = 1] = "Active";
    UserSearchStatuses[UserSearchStatuses["Inactive"] = 2] = "Inactive";
})(UserSearchStatuses || (UserSearchStatuses = {}));
